// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/prototype-construction/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const prototypeConstructionEN: PageEntry = {
  id: "post.musterkonstruktion",
  locale: "en",
  slug: "prototype-construction",
  seo: {
    title: "Glossary: Prototype construction explained simply | Dietz GmbH",
    description: "Prototype construction refers to the detailed process of working out the technical aspects of a pattern, particularly in the textile and apparel industry. This includes defining cu",
  },
  type: "post",
  h1: "Glossary: Prototype construction explained simply",
  intro: "Prototype construction refers to the detailed process of working out the technical aspects of a pattern, particularly in the textile and apparel industry. This includes defining cutting patterns, sewing tolerances, material requirements and other technical details relevant to mass production. Prototype construction ensures that the development work is seamlessly transferred to the production phase and that all required specifications are met. Precise sample construction is crucial for the reproducibility and quality of products.",
  blocks: [

  ],
};
